import { render, staticRenderFns } from "./MovableView.vue?vue&type=template&id=32704e3a&scoped=true&"
import script from "./MovableView.vue?vue&type=script&lang=js&"
export * from "./MovableView.vue?vue&type=script&lang=js&"
import style0 from "./MovableView.vue?vue&type=style&index=0&id=32704e3a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32704e3a",
  null
  
)

export default component.exports